import { render, staticRenderFns } from "./EmailOnboardingSidePanel.vue?vue&type=template&id=0137cfb0&"
import script from "./EmailOnboardingSidePanel.vue?vue&type=script&lang=js&"
export * from "./EmailOnboardingSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports